import type { ComponentPropsWithoutRef, ReactNode } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";

export interface FixedActionSidebarProps
  extends ComponentPropsWithoutRef<"aside"> {
  children: ReactNode;
  className?: string;
}

export const FixedActionSidebar = ({
  children,
  className,
  ...rest
}: FixedActionSidebarProps) => (
  <aside
    className={classNames(
      "bg-primary z-[-10] flex h-full flex-col shadow-[4px_0_10px_-3px_rgb(0,0,0,0.1)]",
      className,
    )}
    {...rest}
  >
    {children}
  </aside>
);
